import { motion } from "framer-motion";
import CountUp from "react-countup";
import { STATS } from "../data/content";

const Stats = () => (
    <section data-testid="stats-section" className="relative py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
                {STATS.map((s, i) => (
                    <motion.div
                        key={s.label}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.45, delay: i * 0.08 }}
                        data-testid={`stat-${i}`}
                        className="relative p-6 sm:p-8 rounded-3xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden"
                    >
                        <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full bg-brand-500/10 blur-2xl" />
                        <div className="relative">
                            <div className="font-heading text-4xl sm:text-5xl font-extrabold text-gradient-brand">
                                <CountUp end={s.value} duration={2.5} enableScrollSpy scrollSpyOnce />{s.suffix}
                            </div>
                            <div className="mt-2 text-sm text-slate-500 dark:text-slate-400 font-medium tracking-wide">{s.label}</div>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);

export default Stats;
